// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
// Agreements Content Handle the gRPC endpoints related to the insys agreements service. 
// The endpoints are implemented in the insys-agreements-content related services.
export const AgreementContentService = {
    // ReadByFeature returns feature details
    ReadByFeature(fn, req) {
        try {
            fm.validateUrlParam(req["feature"], "feature");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/agreementcontent/v1/getfeature/${req["feature"]}?${fm.renderURLSearchParams(req, ["feature"])}`, { method: "GET" });
    },
    // ReadByID returns feature details
    ReadByID(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/agreementcontent/v1/getid/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
};
